import DashboardLayout from "components/Dashboard/Layout";

const DashboardHome = () => {
  return <DashboardLayout type="lec">home</DashboardLayout>;
};

export default DashboardHome;
